import LangEnum from '../../../../lang/LangEnum';
import useGeneralSettingsStore from '../../../../stores/GeneralSettings/useGeneralSettingsStore';
import { useApplicationContext } from '../../../context/ApplicationContext/ApplicationContext';
import OrderContractSignatureRequired from '../../../general-settings/enums/orderContractSignatureRequired.enum';
import { useOrderContext } from '../../contexts/Order.context';
import { SignatureContextType } from '../contexts/signature.context.types';
import {
  getValidContract,
  hasManualContracts,
  isAutoSignEnabled,
  isCurrentUserRequiredToSign,
  isLastRequiredSigner,
} from '../selectors/signedContracts/signedContracts.selectors';

const useSignedContractSelectors = () => {
  const { isBrand } = useApplicationContext();
  const { order } = useOrderContext();
  const { autoContractGeneration, orderContractSignatureRequired } = useGeneralSettingsStore(
    (s) => s.generalSettings,
  );

  const signedContracts = order?.signedContracts ?? [];
  const contract = getValidContract({ signedContracts });
  const shouldISign = isCurrentUserRequiredToSign({
    isBrand,
    setting: orderContractSignatureRequired,
  });

  const getActionLabel = () =>
    shouldISign ? LangEnum.GLOBAL_SIGN_ORDER : LangEnum.GLOBAL_REQUEST_SIGNATURE;

  const getModalContent = () => {
    if (orderContractSignatureRequired === OrderContractSignatureRequired.BY_STORE_AND_BRAND) {
      return LangEnum.SIGN_ORDER_MODAL_BODY_BY_STORE_AND_BRAND;
    }

    if (isBrand) {
      return LangEnum.SIGN_ORDER_MODAL_BODY_BY_STORE_AS_BRAND;
    }

    return LangEnum.SIGN_ORDER_MODAL_BODY_BY_STORE_AS_STORE;
  };

  return {
    shouldISign,
    isAutoSignEnabled: isAutoSignEnabled({
      autoContractGeneration,
      orderContractSignatureRequired,
    }),
    hasManualContracts: hasManualContracts({ signedContracts }),
    isLastRequiredSigner: (signingAs: SignatureContextType.SigningAs) =>
      isLastRequiredSigner({ contract, signingAs, setting: orderContractSignatureRequired }),
    actionLabel: getActionLabel(),
    modalContent: getModalContent(),
  };
};

export default useSignedContractSelectors;
